"use strict";
import Home_vue from '@/vue/apps/home/live.vue'
import Vue from 'vue'
import Vuex from "vuex"
// import store from '@/vue/store/'
import core from '@/js/core/core'
import EventBus from '@/vue/events/event-bus'

history.pushState(null, null, location.href);
Vue.use(Vuex)
const store = new Vuex.Store({
    state : {
      _theme: window.theme,
      arr_lang: window.lang,
      titleSport: window.titleSport,
      lang_id: window.lang_id,
      liveMatchList: [],
      sortedliveMatchList: [],
      selectedMatch: {},
      selectedSport: '',
      firstLoad: 1,
      keyword: '',
      minWidth: 1100,
      isMobile: window.innerWidth < 1100,
      loginToken: window.loginToken,
      error: {},
    },
    getters: {
      _theme: state => state._theme,
      arr_lang: state => {
          return state.arr_lang
      },
      titleSport: state => state.titleSport,
      lang_id: state => state.lang_id,
      liveMatchList: state=>state.liveMatchList,
      sortedliveMatchList: state=>state.sortedliveMatchList,
      selectedMatch: state=>state.selectedMatch,
      selectedSport: state=>state.selectedSport,
      firstLoad: state=>state.firstLoad,
      keyword: state=>state.keyword,
      minWidth: state=>state.minWidth,
      isMobile: state=>state.isMobile,
      loginToken: state=>state.loginToken,
      error: state=>state.error,
    },
    actions : {
      getLiveMatchList(context, payload){
          var url = window._baseUrl + '/sport-live-match'
          var data = {
              lang: payload.lang,
              limitDisplay: window.limitDisplay,
              loginToken: this.getters.loginToken,
          }
          // if(payload.sport != '') {
          //   data.sport = payload.sport;
          // }
          core.$ajax({
            method: 'get',
            url: url,
            data: data
          }).done(((res)=> {
            function getSelectedSport(data, selectedSport, titleSport) {
              const now = new Date();
              const sportSequence = titleSport.flatMap(item => item.sid);

              const hasRunningRB = (sportid) => {
                if (!data[sportid]) return false;
                return Object.values(data[sportid]).some(draw => {
                  const dt = new Date(draw.dt.replace(' ', 'T') + '-04:00');
                  return dt <= now;
                });
              };

              if (selectedSport && hasRunningRB(selectedSport)) {
                return selectedSport;
              }

              const autoSport = sportSequence.find(sportid => hasRunningRB(sportid));
              if (autoSport) return autoSport;

              return Object.keys(data)[0] || '';
            }

            // console.log(res)
            if(res.error) {
              EventBus.$emit('stopTimer')
              this.commit('SET_ERROR', res)
            } else {
              this.commit('SET_ERROR', {})
            }
            var data = res.data? res.data:[]
            
            if(data.length > 0 || Object.keys(data).length > 0) {
              var selectedSpt = (payload.sport != '' && payload.sport != undefined)? payload.sport:getSelectedSport(data, this.getters.selectedSport, this.getters.titleSport)

              if(this.getters.selectedSport != selectedSpt){
                this.commit('SELECTED_SPORT', selectedSpt)
              }
              
              const selectedMatch = this.getters.selectedMatch
              const currentSportMatches = data[selectedSpt]? Object.values(data[selectedSpt]):[];
              // if selected match empty
              if (!selectedMatch || Object.keys(selectedMatch).length === 0) {
                this.dispatch('updateSelectedMatch',((currentSportMatches.length > 0)? currentSportMatches[0]:{}));
              } else {
                // get all sport matches
                const allMatches = Object.values(data).flatMap(sport =>
                  Object.values(sport)
                );
                // find if selected match exists in new data
                const matchExists = allMatches.some(
                  m => m.eveid === selectedMatch.eveid
                );
                // if not exist
                if (!matchExists) {
                  const fallbackSport = getSelectedSport(data, this.getters.selectedSport, this.getters.titleSport);
                  if (fallbackSport !== this.getters.selectedSport) {
                    this.commit('SELECTED_SPORT', fallbackSport);
                  }
                  const fallbackMatches = data[fallbackSport]? Object.values(data[fallbackSport]):[];
                  this.dispatch('updateSelectedMatch',((fallbackMatches.length > 0)? fallbackMatches[0]:{}));
                } else {
                  if (selectedMatch.sptid !== this.getters.selectedSport) {
                    this.dispatch('updateSelectedMatch',((currentSportMatches.length > 0)? currentSportMatches[0]:{}));
                  }
                }
              }
            } else {
              this.commit('SELECTED_SPORT', (payload.sport != '' && payload.sport != undefined)? payload.sport:'1')
              this.dispatch('updateSelectedMatch', {})
            }

            this.commit('LIVE_MATCH_LIST', data)
            this.dispatch('sortLiveMatch')

          }).bind(this)).catch((errRes)=> {
            console.log(errRes)
          })
      },
      sortLiveMatch(context, payload) {
        const ret = this.getters.liveMatchList
        const selectedSport = this.getters.selectedSport
        var newSortedEvents = []
        const keyword = (this.getters.keyword).trim().toLowerCase() // $('#searchInput').val().trim().toLowerCase()

        if((ret.length > 0 || Object.keys(ret).length > 0) && ret[selectedSport]) {
          if(keyword) {
            const res = Object.values(ret)
                        .flatMap(events => Object.values(events))
                        .sort((a, b) => Number(a.evedt) - Number(b.evedt));
            _.forEach(res, function(val, key){
              if(!keyword 
                  || (keyword && 
                    ((val.lgecap && val.lgecap.trim().toLowerCase().includes(keyword)) 
                      || (val.tacap && val.tacap.trim().toLowerCase().includes(keyword)) 
                      || (val.tbcap && val.tbcap.trim().toLowerCase().includes(keyword)))) 
                ) {
                    newSortedEvents.push(val)
                  }
            });
          } else {
            newSortedEvents = Object.values(ret[selectedSport])
          }
        }
        this.commit('SORTED_LIVE_MATCH_LIST', newSortedEvents)
      },
      updateSelectedMatch(context, payload){
        if(payload && Object.keys(payload).length > 0) {
          this.dispatch('getLiveStreamURL', {
              ch: payload.ch, 
              eveid: payload.eveid,
              sptid: payload.sptid
          }).then(tvlink => {
            const updatedPayload = {
              ...payload,
              tvlink: tvlink
            };
            this.commit('SELECTED_MATCH', updatedPayload);
          }).catch(err => {
            console.error('Failed to get live stream URL:', err);
            const updatedPayload = { ...payload, tvlink: null };
            this.commit('SELECTED_MATCH', updatedPayload);
          });
        } else {
          this.commit('SELECTED_MATCH', { ...payload });
        }
      },
      getLiveStreamURL(context, payload){
        return new Promise((resolve, reject) => {
          var url = window._baseUrl + '/livetv'
          var data = {
              chlid: payload.ch, 
              eventid: payload.eveid,
              sptid: payload.sptid,
              livepage: 1,
              passkey: window.passkey_det.passkey,
              passkeyid: window.passkey_det.id,
              // league: payload.lgecapt,
              // tacap: payload.tacapt,
              // tbcap: payload.tbcapt
          }
          core.$ajax({
            method: 'post',
            url: url,
            data: data
          }).done(res => {
            resolve(res);
          }).catch(err => {
            console.error(err);
            reject(err);
          });
        });
      },
    },
    mutations: {
      SKIN_THEME(state, payload) {
        state._theme = payload;
      },
      LIVE_MATCH_LIST(state, payload){
        state.liveMatchList = payload
      },
      SORTED_LIVE_MATCH_LIST(state, payload){
        state.sortedliveMatchList = payload
      },
      SELECTED_MATCH(state, payload){
        state.selectedMatch = payload
        if(this.getters.firstLoad == 1) {
          this.commit('FIRST_LOAD', 0);
        }
      },
      SELECTED_SPORT(state, payload){
        state.selectedSport = payload
      },
      FIRST_LOAD(state, payload){
        state.firstLoad = payload
        const wait_lang = this.getters.arr_lang.home['HOME.LIVESTREAM_WAIT']
        const no_match_lang = this.getters.arr_lang.home['HOME.NO_LIVE_NOW']
        $('.leftMLS-col-text').each(function () {
            let text = (payload === 1)? wait_lang.trim():no_match_lang.trim();
            let html = '';

            for (let i = 0; i < text.length; i++) {
                let delay = i * 0.08;
                let char = text[i] === ' ' ? '&nbsp;' : text[i];
                html += `<span style="animation-delay:${delay}s">${char}</span>`;
            }

            $(this).html(html);
        });
      },
      SET_KEYWORD(state, payload){
        state.keyword = payload
      },
      IS_MOBILE(state, payload){
        state.isMobile = payload
      },
      SET_ERROR(state, payload){
        state.error = payload
      },
    }
});

new Vue({
  el: '#landing',
  template: '<Home></Home>',
  store: store,
  components: {
    Home: Home_vue
  },
})



// WEBPACK FOOTER //
// ./resources/score/js/home/live.js